import { render } from "./Home.vue?vue&type=template&id=18c0dca5&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=18c0dca5&scoped=true&lang=css"

import exportComponent from "F:\\unilearn\\unilearn-web-vue3\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c0dca5"]])

export default __exports__